<template>
  <base-card class="risk-status-card" :class="riskStatusClass" v-if="currentRiskStatusReference">
    <div class="row align-items-center justify-content-between ml-1 p-3 flex-nowrap">
      <div class="col-xs-3 pr-3 ml-1">
        <font-awesome-icon class="risk-status-icon" :icon="['fas', 'virus']"></font-awesome-icon>
      </div>
      <div class="col-xs-9 mr-auto">
        <h5 class="m-0 p-0">{{ $t('riskStatusCard.riskStatus', { riskStatus: currentRiskStatus.attributes.name.en }) }}</h5>
        <p class="m-0 p-0">{{ $t('riskStatusCard.lastUpdated', { lastUpdated: riskLastUpdatedAt }) }}</p>
      </div>
      <div class="col-xs-3 mr-2">
        <font-awesome-icon class="chevron" :icon="['fal', 'chevron-right']"></font-awesome-icon>
      </div>
    </div>
  </base-card>
</template>

<script>
import { format } from 'date-fns';
import { mapState } from 'vuex';
import BaseCard from '../base-card/base-card.vue';
import common from "@/mixins/common";

export default {
  name: 'RiskStatusCard',
  mixins: [common],
  components: {
    BaseCard,
  },
  computed: {
    ...mapState(['currentRiskStatus', 'currentRiskStatusReference']),
    riskStatusClass() {
      let riskClass = 'low';
      if (this.currentRiskStatus && this.currentRiskStatus.attributes) {
        riskClass = this.grabI18NTranslation(this.currentRiskStatus.attributes.name);
        if (riskClass) {
          riskClass = riskClass.toLowerCase();
        }
        this.log('RiskStatusCard -> riskStatusClass', 'riskClass', riskClass);
      }
      return riskClass;
    },
    riskLastUpdatedAt() {
      let updatedAt =  '';
      if (this.currentRiskStatusReference && this.currentRiskStatusReference.meta) {
        updatedAt = format(new Date(this.currentRiskStatusReference.meta.updated_at), 'yyyy/MM/dd - h:mm a');
      }
      this.log('RiskStatusCard -> riskLastUpdatedAt', 'updatedAt', updatedAt);
      return updatedAt;
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
